import React, { Suspense } from 'react';

/**
 * Load the svg components in a javascript webpack chunk.
 * This prevents large main bundles, using dynamic import().
 *
 * @see https://reactjs.org/docs/code-splitting.html#reactlazy
 */
const BackgroundStar = React.lazy(() => import(
    /* webpackChunkName: "star-background"*/
    './star-background'
));
const BackgroundBlue = React.lazy(() => import(
    /* webpackChunkName: "blue-background"*/
    './blue-background'
));

export function FormBackgrounds () {
    return (
        // perhaps the skeleton looks bad here a big grey circle?
        <Suspense fallback={null}>
            <BackgroundStar />
            <BackgroundBlue />
        </Suspense>
    );
}
